import { render, staticRenderFns } from "./trainVetVideoDetail.vue?vue&type=template&id=c332c07a&scoped=true&"
import script from "./trainVetVideoDetail.vue?vue&type=script&lang=js&"
export * from "./trainVetVideoDetail.vue?vue&type=script&lang=js&"
import style0 from "./trainVetVideoDetail.vue?vue&type=style&index=0&id=c332c07a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c332c07a",
  null
  
)

export default component.exports